module.exports = __webpack_public_path__ + "img/mc-repeat-all.07f20a73.svg";